import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { IDeltaHedgeExeCommonSearchParam } from "../../../Interfaces/deltaHedgeExe";
import { getExeDecrementalOrdersTable } from "../../../Requests/deltaHedgeExe";


interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const OrdersTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getExeDecrementalOrdersTable}
      searchParameters={searchParams}
    />
  );
};

export default OrdersTable;
